export interface IRoleChooser {
    [role: string]: IRoleChooser;
}

export type RoleChooserState = {
    roles?: IRoleChooser;
    activeRole: IRoleChooser;
    loading: boolean;
    error?: string;
};

export enum Role {
    PRIVATE = 'Privatperson',
    ORGREP = 'Organisasjonsrepresentant',
    ESTATEOWNER = 'Eier av eiendom'
}